import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "background", "borderRadius", "borderWidth", "children", "padding", "paddingBlock", "paddingBlockEnd", "paddingBlockStart", "paddingInline", "paddingInlineEnd", "paddingInlineStart"];
import { forwardRef } from 'react';
import styled from 'styled-components';
import { LayoutBox } from './LayoutBox';
import { makeCustomProperty } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const borderWidthMap = {
  border: 'border-width',
  'border-double': 'border-width-double'
};
const BreezeBorder = styled(LayoutBox).withConfig({
  displayName: "LayoutBoxBreezeBorder__BreezeBorder",
  componentId: "sc-1s6eyc9-0"
})(["--background:", ";background-image:linear-gradient(var(--background),var(--background)),var(--layout-lib-gradient-breeze-medium);background-origin:border-box;background-clip:content-box,border-box;", " overflow:hidden;"], ({
  $background
}) => makeCustomProperty($background), ({
  $borderWidth
}) => `border: solid var(--layout-lib-${$borderWidth}) transparent;`);
export const LayoutBoxBreezeBorder = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as,
      background = 'background-color-light',
      borderRadius = 'border-radius',
      borderWidth = 'border',
      children,
      padding,
      paddingBlock,
      paddingBlockEnd,
      paddingBlockStart,
      paddingInline,
      paddingInlineEnd,
      paddingInlineStart
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(BreezeBorder, Object.assign({}, rest, {
    $background: background,
    $borderWidth: borderWidthMap[borderWidth],
    borderRadius: borderRadius,
    forwardedAs: as,
    ref: ref,
    children: /*#__PURE__*/_jsx(LayoutBox, {
      as: as,
      blockSize: "100%",
      borderRadius: borderRadius,
      inlineSize: "100%",
      padding: padding,
      paddingBlock: paddingBlock,
      paddingBlockEnd: paddingBlockEnd,
      paddingBlockStart: paddingBlockStart,
      paddingInline: paddingInline,
      paddingInlineEnd: paddingInlineEnd,
      paddingInlineStart: paddingInlineStart,
      children: children
    })
  }));
});